import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class AdvertCloseButton extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-advert__close',
            className,
        ];
    }

}

AdvertCloseButton.propTypes = propTypes;

AdvertCloseButton.defaultProps = defaultProps;

export default AdvertCloseButton;
